// Most tracking events are passed into the library.
// In some cases where features are not context specific, we may use the events below.
import { TrackingEvent, TrackingEventTypes } from '@cinch-nx/shared-analytics'

export const financeBudgetTopButton = (): TrackingEvent => ({
  eventName: 'Finance budget calculator - Banner button click to scroll',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: 'budget calculator',
      category: 'finance page',
      name: 'click',
      label: 'banner button',
    },
  },
})

export const financeBudgetCalculator = (
  type: 'PCP' | 'HP',
  budget: string,
): TrackingEvent => ({
  eventName: 'Finance budget calculator - Search all cars',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: 'budget calculator',
      category: 'finance page',
      name: 'click',
      label: `${type} | ${budget}`,
    },
  },
})

export const understandingFinanceClick = (
  title: string,
  question: string,
): TrackingEvent => ({
  eventName: 'Finance content page - Understanding finance click',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: title,
      category: 'finance page',
      name: 'click',
      label: question,
    },
  },
})

export const calculatorHpExplainedSelected = (): TrackingEvent => ({
  eventName: 'Finance - Selected HP Explained',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: 'open',
      category: 'tooltip',
      name: 'click',
      label: 'hp-explained',
    },
  },
})

export const calculatorPcpExplainedSelected = (): TrackingEvent => ({
  eventName: 'Finance - Selected PCP Explained',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: 'open',
      category: 'tooltip',
      name: 'click',
      label: 'pcp-explained',
    },
  },
})

export const searchAllCarsClick = (): TrackingEvent => ({
  eventName: 'Finance content page - Search all cars',
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      action: 'search all cars cta click bottom',
      category: 'finance page',
      name: 'click',
    },
  },
})
